(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Minutesofmeeting', Minutesofmeeting);

    Minutesofmeeting.$inject = ['$resource'];

    function Minutesofmeeting ($resource) {
        var resourceUrl =  'api/minutesofmeetings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
